import React from "react";
import AdminRoutes from "../routes/AdminRoutes";
import Sidebar from "../components/common/Sidebar";
import Header from "../components/common/Header";
import ImpersonationBanner from "../components/common/ImpersonationBanner";
import { SidebarProvider, useSidebar } from "../context/SidebarContext";

const AdminLayoutContent: React.FC = () => {
  const { sidebarWidth } = useSidebar();

  return (
    <div className="min-h-screen bg-[#f4f6f8] text-slate-900 font-sans antialiased">
      <ImpersonationBanner />
      <Sidebar />

      <div
        className="min-h-screen transition-[margin] duration-200"
        style={{ marginLeft: `${sidebarWidth}px` }}
      >
        <Header />

        <main className="min-h-[calc(100vh-4rem)] pt-16 overflow-y-auto">
          <div className="mx-auto w-full max-w-[1800px] p-4 md:p-6 lg:p-8">
            <AdminRoutes />
          </div>
        </main>
      </div>
    </div>
  );
};

const AdminLayout: React.FC = () => (
  <SidebarProvider>
    <AdminLayoutContent />
  </SidebarProvider>
);

export default AdminLayout;
